import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = 'auto' }) => {
  return (
    <svg
      width={width}
      height={height}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 226.1 81.3"
      style={{ enableBackground: 'new 0 0 226.1 81.3' }}>
      <g>
        <path style={{ fill: '#070707' }} d="M82.4,34.4l-3-4.7l-1.5,1.9v2.7h-1.7V24.2h1.7v4.9l3.8-4.9h2.1l-3.2,4.1l3.9,6.1H82.4z" />
        <path
          style={{ fill: '#070707' }}
          d="M90.6,33.3c-0.5,0.9-1.3,1.3-2.6,1.3c-2.1,0-3.2-1.4-3.2-3.3v-1c0-2.2,1.1-3.3,3-3.3c2,0,3,1.2,3,3.4v0.8h-4.4
		v0c0,1.2,0.4,2.1,1.6,2.1c0.9,0,1.2-0.3,1.5-0.7L90.6,33.3z M86.3,29.9h2.8c-0.1-1.1-0.5-1.6-1.4-1.6
		C86.8,28.3,86.4,28.9,86.3,29.9z"
        />
        <path style={{ fill: '#070707' }} d="M92.2,24.2h1.6v7.5c0,0.8,0.1,1.3,1.1,1.3v1.4c-1.9,0-2.7-0.6-2.7-2.3V24.2z" />
        <path style={{ fill: '#070707' }} d="M96.4,24.2H98v7.5c0,0.8,0.1,1.3,1.1,1.3v1.4c-1.9,0-2.7-0.6-2.7-2.3V24.2z" />
        <path
          style={{ fill: '#070707' }}
          d="M106.1,33.3c-0.5,0.9-1.3,1.3-2.6,1.3c-2.1,0-3.2-1.4-3.2-3.3v-1c0-2.2,1.1-3.3,3-3.3c2,0,3,1.2,3,3.4v0.8
		h-4.4v0c0,1.2,0.4,2.1,1.6,2.1c0.9,0,1.2-0.3,1.5-0.7L106.1,33.3z M101.8,29.9h2.8c-0.1-1.1-0.5-1.6-1.4-1.6
		C102.3,28.3,101.9,28.9,101.8,29.9z"
        />
        <path style={{ fill: '#070707' }} d="M108.4,27l1.9,5.2L112,27h1.6l-2.6,7.7c-0.6,1.9-1.2,2.5-3.2,2.5v-1.4c1,0,1.4-0.2,1.8-1.3l-2.8-7.5H108.4z" />
        <path
          style={{ fill: '#070707' }}
          d="M121.8,24.2c2.4,0,3.6,0.9,3.6,2.6c0,1-0.6,1.9-1.5,2.2c1.2,0.3,1.8,1.1,1.8,2.4c0,1.5-1,2.9-3.6,2.9h-3.6
		V24.2H121.8z M120.2,28.4h1.7c1.3,0,1.8-0.6,1.8-1.4c0-0.8-0.4-1.3-2-1.3h-1.4L120.2,28.4L120.2,28.4z M120.2,33h1.8
		c1.4,0,2-0.6,2-1.5c0-1.1-0.7-1.5-2.2-1.5h-1.6C120.2,29.9,120.2,33,120.2,33z"
        />
        <path style={{ fill: '#070707' }} d="M127.1,24.2h1.6v7.5c0,0.8,0.1,1.3,1.1,1.3v1.4c-1.9,0-2.7-0.6-2.7-2.3V24.2z" />
        <path
          style={{ fill: '#070707' }}
          d="M137.3,34.4h-1.6v-0.7c-0.3,0.5-0.8,0.8-1.8,0.8c-1.5,0-2.7-0.8-2.7-2.9V27h1.6v4.4c0,1.3,0.6,1.7,1.4,1.7
		c1,0,1.5-0.7,1.5-1.7V27h1.6C137.3,27,137.3,34.4,137.3,34.4z"
        />
        <path
          style={{ fill: '#070707' }}
          d="M144.6,33.3c-0.5,0.9-1.3,1.3-2.6,1.3c-2.1,0-3.2-1.4-3.2-3.3v-1c0-2.2,1.1-3.3,3-3.3c2,0,3,1.2,3,3.4v0.8
		h-4.4v0c0,1.2,0.4,2.1,1.6,2.1c0.9,0,1.2-0.3,1.5-0.7L144.6,33.3z M140.3,29.9h2.8c-0.1-1.1-0.5-1.6-1.4-1.6
		C140.8,28.3,140.4,28.9,140.3,29.9z"
        />
        <path
          style={{ fill: '#070707' }}
          d="M153.5,24.2c2.4,0,3.6,0.9,3.6,2.6c0,1-0.6,1.9-1.5,2.2c1.2,0.3,1.8,1.1,1.8,2.4c0,1.5-1,2.9-3.6,2.9h-3.6
		V24.2H153.5z M151.9,28.4h1.7c1.3,0,1.8-0.6,1.8-1.4c0-0.8-0.4-1.3-2-1.3h-1.4L151.9,28.4L151.9,28.4z M151.9,33h1.8
		c1.4,0,2-0.6,2-1.5c0-1.1-0.7-1.5-2.2-1.5h-1.6V33z"
        />
        <path
          style={{ fill: '#070707' }}
          d="M164.8,31.2c0,2-1,3.4-3.1,3.4c-2.1,0-3.1-1.3-3.1-3.4v-0.9c0-2.2,1.2-3.4,3.1-3.4c2,0,3.1,1.2,3.1,3.4V31.2z
		 M163.2,31.2v-0.9c0-1.3-0.5-2-1.6-2c-1.1,0-1.6,0.7-1.6,2v0.9c0,1.2,0.4,2.1,1.6,2.1C162.8,33.2,163.2,32.3,163.2,31.2z"
        />
        <path
          style={{ fill: '#070707' }}
          d="M172.1,31.2c0,2-1,3.4-3.1,3.4c-2.1,0-3.1-1.3-3.1-3.4v-0.9c0-2.2,1.2-3.4,3.1-3.4c2,0,3.1,1.2,3.1,3.4V31.2z
		 M170.6,31.2v-0.9c0-1.3-0.5-2-1.6-2c-1.1,0-1.6,0.7-1.6,2v0.9c0,1.2,0.4,2.1,1.6,2.1C170.1,33.2,170.6,32.3,170.6,31.2z"
        />
        <path style={{ fill: '#070707' }} d="M179.5,27l-2.8,3.2l3.3,4.2H178l-2.4-3l-0.5,0.6v2.4h-1.6V24.2h1.6v5.7l2.5-2.9H179.5z" />
      </g>
      <g>
        <path style={{ fill: '#070707' }} d="M80.2,39.4l3.1,9.3l3.1-9.3h4.3l-5.6,15.4h-3.6l-5.6-15.4H80.2z" />
        <path
          style={{ fill: '#070707' }}
          d="M94.1,48h2.1v-0.3c0-1.1-0.2-1.5-1.9-1.5c-1,0-1.5,0.2-1.9,0.8l-2.5-1.6c0.9-1.4,2.3-1.9,4.9-1.9
		c3.1,0,5,0.8,5,4.3v7.1h-3.5v-0.9c-0.4,0.6-1.1,1.1-2.4,1.1c-2.3,0-4.2-1.2-4.2-3.6C89.7,49.2,91.6,48,94.1,48z M96.2,50.4h-1.6
		c-0.9,0-1.4,0.3-1.4,1c0,0.6,0.6,1,1.5,1c1.2,0,1.6-0.7,1.6-1.7V50.4z"
        />
        <path style={{ fill: '#070707' }} d="M101,39.4h3.6v11c0,1.2,0.6,1.5,1.5,1.5v2.9c-3.3,0-5.1-0.6-5.1-3.6V39.4z" />
        <path
          style={{ fill: '#070707' }}
          d="M117.5,54.8H114V54c-0.5,0.7-1,1.1-2.5,1.1c-2.3,0-4.4-1.1-4.4-4.4v-7h3.6V50c0,1.5,0.4,2.2,1.6,2.2
		c1.2,0,1.7-0.6,1.7-2.2v-6.4h3.6V54.8z"
        />
        <path
          style={{ fill: '#070707' }}
          d="M128.4,53.1c-0.8,1.4-2.3,1.9-4.5,1.9c-3.8,0-5.4-2.3-5.4-5.1v-1.6c0-3.5,1.9-5,5-5c3.5,0,5,1.9,5,5.3v1.3
		h-6.5c0,1.3,0.4,2.1,1.8,2.1c1.1,0,1.4-0.3,1.8-0.8L128.4,53.1z M122.1,47.9h2.8c-0.1-1.2-0.6-1.6-1.4-1.6
		C122.6,46.2,122.2,46.9,122.1,47.9z"
        />
        <path
          style={{ fill: '#070707' }}
          d="M136.1,47.1c-0.5-0.5-0.9-0.8-2-0.8c-0.5,0-1.1,0.1-1.1,0.6c0,0.4,0.4,0.6,1.5,0.8c3.3,0.6,4.5,1.8,4.5,3.9
		c0,2.2-1.7,3.6-4.8,3.6c-2.4,0-4-0.5-5.1-1.9l2.8-1.9c0.4,0.5,0.9,0.9,2.2,0.9c0.8,0,1.3-0.2,1.3-0.6c0-0.4-0.4-0.6-1.5-0.8
		c-2.7-0.6-4.5-1.6-4.5-3.8c0-2.2,1.7-3.6,4.8-3.6c2,0,3.7,0.4,4.6,1.9L136.1,47.1z"
        />
      </g>
      <path
        style={{ fill: '#E5EAE6' }}
        d="M4.5,47.3C4.5,47.3,4.5,47.3,4.5,47.3c0-17.5,14.1-31.6,31.5-31.6c17.4,0,31.5,14.1,31.5,31.5c0,0,0,0,0,0.1
	H4.5z"
      />
      <g>
        <defs>
          <polygon id="SVGID_1_" points="2.5,53.5 39.3,53.4 17.1,14 2.7,14 		" />
        </defs>
        <clipPath id="SVGID_2_">
          <use xlinkHref="#SVGID_1_" style={{ overflow: 'visible' }} />
        </clipPath>
        <g style={{ clipPath: 'url(#SVGID_2_)' }}>
          <linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="351.7633" y1="51.9491" x2="345.5545" y2="41.8357" gradientTransform="matrix(-1 0 0 1 400.8346 0)">
            <stop offset="0" style={{ stopColor: '#C82038' }} />
            <stop offset="1" style={{ stopColor: '#E84745' }} />
          </linearGradient>
          <path style={{ display: 'none', fill: 'url(#SVGID_3_)' }} d="M58.5,25.1c5.6,5.7,9.1,13.5,9.1,22.1c0,0,0,0,0,0.1H36.3L58.5,25.1z" />

          <linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="385.876" y1="51.2501" x2="381.063" y2="43.4105" gradientTransform="matrix(-1 0 0 1 400.8346 0)">
            <stop offset="0" style={{ stopColor: '#C82038' }} />
            <stop offset="1" style={{ stopColor: '#E84745' }} />
          </linearGradient>
          <path style={{ fill: 'url(#SVGID_4_)' }} d="M35.8,47.3H4.5c0,0,0,0,0-0.1c0-8.6,3.5-16.5,9.1-22.1L35.8,47.3z" />
        </g>

        <radialGradient id="SVGID_5_" cx="377.7867" cy="35.9096" r="15.8699" gradientTransform="matrix(-1 0 0 1 400.8346 0)" gradientUnits="userSpaceOnUse">
          <stop offset="6.467690e-02" style={{ stopColor: '#D75B4F' }} />
          <stop offset="0.353" style={{ stopColor: '#D04D45' }} />
          <stop offset="0.8979" style={{ stopColor: '#BF282A' }} />
          <stop offset="1" style={{ stopColor: '#BB2025' }} />
        </radialGradient>
        <path
          style={{ clipPath: 'url(#SVGID_2_)', fill: 'url(#SVGID_5_)' }}
          d="M4.5,47.3C4.5,47.3,4.5,47.3,4.5,47.3c0-17.5,14.1-31.6,31.5-31.6c17.4,0,31.5,14.1,31.5,31.5c0,0,0,0,0,0.1
		H4.5z"
        />
      </g>
      <polygon style={{ fill: 'none' }} points="36,47.6 58.9,8.7 14.2,8.9 " />
      <g>
        <g>
          <path style={{ fill: '#569451' }} d="M17.7,15.1c2.6-1.5,5.5-2.7,8.6-3.5c10.1-2.8,20.4-1.2,28.8,3.7L36.5,47.9l-0.3,0.1L17.7,15.1z" />
        </g>
        <defs>
          <filter id="Adobe_OpacityMaskFilter" filterUnits="userSpaceOnUse" x="17.7" y="10.2" width="37.4" height="37.8">
            <feColorMatrix type="matrix" values="-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0" color-interpolation-filters="sRGB" result="source" />
          </filter>
        </defs>
        <mask maskUnits="userSpaceOnUse" x="17.7" y="10.2" width="37.4" height="37.8" id="SVGID_6_">
          <g style={{ filter: 'url(#Adobe_OpacityMaskFilter)' }}>
            <image style={{ overflow: 'visible' }} width="43" height="43" xlinkHref="ADD8D464DEB6B9F6.jpg" transform="matrix(1 0 0 1 15 7.347)"></image>
          </g>
        </mask>
        <g style={{ opacity: '0.12', mask: 'url(#SVGID_6_)' }}>
          <path style={{ fill: '#FFFFFF' }} d="M17.7,15.1c2.6-1.5,5.5-2.7,8.6-3.5c10.1-2.8,20.4-1.2,28.8,3.7L36.5,47.9l-0.3,0.1L17.7,15.1z" />
        </g>
      </g>
      <g style={{ opacity: '0.2' }}>
        <g>
          <g>
            <polygon style={{ fill: '#569451' }} points="36.5,47.9 36.2,47.9 35.8,47.3 36.8,47.3 			" />
          </g>
          <defs>
            <filter id="Adobe_OpacityMaskFilter_1_" filterUnits="userSpaceOnUse" x="35.8" y="47.3" width="0.9" height="0.6">
              <feColorMatrix type="matrix" values="-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0" color-interpolation-filters="sRGB" result="source" />
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="35.8" y="47.3" width="0.9" height="0.6" id="SVGID_7_">
            <g style={{ filter: 'url(#Adobe_OpacityMaskFilter_1_)' }}>
              <image style={{ overflow: 'visible' }} width="6" height="6" xlinkHref="ADD8D464DEB6B9F1.jpg" transform="matrix(1 0 0 1 33 44.347)"></image>
            </g>
          </mask>
          <g style={{ opacity: '0.12', mask: 'url(#SVGID_7_)' }}>
            <polygon style={{ fill: '#FFFFFF' }} points="36.5,47.9 36.2,47.9 35.8,47.3 36.8,47.3 			" />
          </g>
        </g>
        <g>
          <g>
            <path style={{ fill: '#569451' }} d="M36,15.7c5.9,0,11.5,1.6,16.2,4.5L36.8,47.3h-0.9L20.4,19.9C25,17.2,30.3,15.7,36,15.7z" />
          </g>
          <defs>
            <filter id="Adobe_OpacityMaskFilter_2_" filterUnits="userSpaceOnUse" x="20.4" y="15.7" width="31.8" height="31.6">
              <feColorMatrix type="matrix" values="-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0" color-interpolation-filters="sRGB" result="source" />
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="20.4" y="15.7" width="31.8" height="31.6" id="SVGID_8_">
            <g style={{ filter: 'url(#Adobe_OpacityMaskFilter_2_)' }}>
              <image style={{ overflow: 'visible' }} width="37" height="36" xlinkHref="ADD8D464DEB6B9F3.jpg" transform="matrix(1 0 0 1 18 13.347)"></image>
            </g>
          </mask>
          <g style={{ opacity: '0.12', mask: 'url(#SVGID_8_)' }}>
            <path style={{ fill: '#FFFFFF' }} d="M36,15.7c5.9,0,11.5,1.6,16.2,4.5L36.8,47.3h-0.9L20.4,19.9C25,17.2,30.3,15.7,36,15.7z" />
          </g>
        </g>
      </g>
      <radialGradient id="SVGID_9_" cx="28.6983" cy="185.7932" r="19.3467" gradientTransform="matrix(1 0 0 0.4697 0 -30.8674)" gradientUnits="userSpaceOnUse">
        <stop offset="4.958660e-03" style={{ stopColor: '#D0D9E7' }} />
        <stop offset="0.4172" style={{ stopColor: '#186A9E' }} />
        <stop offset="0.7669" style={{ stopColor: '#005185' }} />
        <stop offset="1" style={{ stopColor: '#1E3B6F' }} />
      </radialGradient>
      <polygon style={{ fill: 'url(#SVGID_9_)' }} points="27,56.3 27,66.9 36.3,63.6 45.6,66.9 45.6,56.3 " />
      <linearGradient id="SVGID_10_" gradientUnits="userSpaceOnUse" x1="24.305" y1="48.095" x2="38.4607" y2="65.0389">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.3763" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4657" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.5676" style={{ stopColor: '#E3B44E' }} />
        <stop offset="0.6237" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.6528" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.7152" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.7921" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8441" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.8919" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="0.9376" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.9439" style={{ stopColor: '#E3AC24' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <polygon style={{ fill: 'url(#SVGID_10_)' }} points="29,66.2 29,39.7 28.1,39.7 28.1,66.5 " />
      <linearGradient id="SVGID_11_" gradientUnits="userSpaceOnUse" x1="35.4959" y1="43.8879" x2="52.9387" y2="67.947">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.2353" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4133" style={{ stopColor: '#E3B44E' }} />
        <stop offset="0.4657" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.5283" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.5694" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.6796" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.7733" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8441" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.8919" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="0.9376" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.9439" style={{ stopColor: '#E3AC24' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <polygon style={{ fill: 'url(#SVGID_11_)' }} points="43.6,66.2 43.6,45.1 44.5,45.1 44.5,66.5 " />
      <radialGradient id="SVGID_12_" cx="27.4371" cy="-65.6678" r="19.1221" gradientTransform="matrix(1 0 0 1.3155 0 102.0711)" gradientUnits="userSpaceOnUse">
        <stop offset="0" style={{ stopColor: '#326AB2' }} />
        <stop offset="0.5124" style={{ stopColor: '#326AB2' }} />
        <stop offset="0.9432" style={{ stopColor: '#203E77' }} />
      </radialGradient>
      <polyline style={{ fill: 'url(#SVGID_12_)' }} points="27,54.1 27,27.1 45.6,27.1 45.6,54.1 " />
      <g>
        <radialGradient id="SVGID_13_" cx="27.4371" cy="18.7148" r="18.665" gradientUnits="userSpaceOnUse">
          <stop offset="0" style={{ stopColor: '#326AB2' }} />
          <stop offset="0.5124" style={{ stopColor: '#326AB2' }} />
          <stop offset="0.9432" style={{ stopColor: '#203E77' }} />
        </radialGradient>
        <polyline style={{ fill: 'url(#SVGID_13_)' }} points="27,47 27,27.1 45.6,27.1 45.6,47 	" />
        <linearGradient id="SVGID_14_" gradientUnits="userSpaceOnUse" x1="36.9836" y1="19.8784" x2="40.7275" y2="30.9813">
          <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
          <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
          <stop offset="0.3763" style={{ stopColor: '#F2D070' }} />
          <stop offset="0.4657" style={{ stopColor: '#ECC35C' }} />
          <stop offset="0.5676" style={{ stopColor: '#E3B44E' }} />
          <stop offset="0.6237" style={{ stopColor: '#AE732A' }} />
          <stop offset="0.6528" style={{ stopColor: '#AE732A' }} />
          <stop offset="0.7152" style={{ stopColor: '#F0D76F' }} />
          <stop offset="0.7921" style={{ stopColor: '#F5E47D' }} />
          <stop offset="0.8441" style={{ stopColor: '#F7F2A5' }} />
          <stop offset="0.8919" style={{ stopColor: '#FFF1C5' }} />
          <stop offset="0.9376" style={{ stopColor: '#E3AC24' }} />
          <stop offset="0.9439" style={{ stopColor: '#E3AC24' }} />
          <stop offset="1" style={{ stopColor: '#FAC94B' }} />
        </linearGradient>
        <polyline style={{ fill: 'url(#SVGID_14_)' }} points="44.5,54.5 44.5,27.1 43.6,27.1 43.6,54.5 	" />
        <linearGradient id="SVGID_15_" gradientUnits="userSpaceOnUse" x1="22.9037" y1="24.1371" x2="26.6477" y2="35.2401">
          <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
          <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
          <stop offset="0.3763" style={{ stopColor: '#F2D070' }} />
          <stop offset="0.4657" style={{ stopColor: '#ECC35C' }} />
          <stop offset="0.5676" style={{ stopColor: '#E3B44E' }} />
          <stop offset="0.6237" style={{ stopColor: '#AE732A' }} />
          <stop offset="0.6528" style={{ stopColor: '#AE732A' }} />
          <stop offset="0.7152" style={{ stopColor: '#F0D76F' }} />
          <stop offset="0.7921" style={{ stopColor: '#F5E47D' }} />
          <stop offset="0.8441" style={{ stopColor: '#F7F2A5' }} />
          <stop offset="0.8919" style={{ stopColor: '#FFF1C5' }} />
          <stop offset="0.9376" style={{ stopColor: '#E3AC24' }} />
          <stop offset="0.9439" style={{ stopColor: '#E3AC24' }} />
          <stop offset="1" style={{ stopColor: '#FAC94B' }} />
        </linearGradient>
        <polyline style={{ fill: 'url(#SVGID_15_)' }} points="29,54.5 29,27.1 28.1,27.1 28.1,54.5 	" />
      </g>
      <g>
        <radialGradient id="SVGID_16_" cx="27.4371" cy="18.7148" r="18.665" gradientUnits="userSpaceOnUse">
          <stop offset="0" style={{ stopColor: '#326AB2' }} />
          <stop offset="0.5124" style={{ stopColor: '#326AB2' }} />
          <stop offset="0.9432" style={{ stopColor: '#203E77' }} />
        </radialGradient>
        <polyline style={{ fill: 'url(#SVGID_16_)' }} points="27,47 27,27.1 45.6,27.1 45.6,47 	" />
        <linearGradient id="SVGID_17_" gradientUnits="userSpaceOnUse" x1="36.9836" y1="19.8784" x2="40.7275" y2="30.9813">
          <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
          <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
          <stop offset="0.3763" style={{ stopColor: '#F2D070' }} />
          <stop offset="0.4657" style={{ stopColor: '#ECC35C' }} />
          <stop offset="0.5676" style={{ stopColor: '#E3B44E' }} />
          <stop offset="0.6237" style={{ stopColor: '#AE732A' }} />
          <stop offset="0.6528" style={{ stopColor: '#AE732A' }} />
          <stop offset="0.7152" style={{ stopColor: '#F0D76F' }} />
          <stop offset="0.7921" style={{ stopColor: '#F5E47D' }} />
          <stop offset="0.8441" style={{ stopColor: '#F7F2A5' }} />
          <stop offset="0.8919" style={{ stopColor: '#FFF1C5' }} />
          <stop offset="0.9376" style={{ stopColor: '#E3AC24' }} />
          <stop offset="0.9439" style={{ stopColor: '#E3AC24' }} />
          <stop offset="1" style={{ stopColor: '#FAC94B' }} />
        </linearGradient>
        <polyline style={{ fill: 'url(#SVGID_17_)' }} points="44.5,54.5 44.5,27.1 43.6,27.1 43.6,54.5 	" />
        <linearGradient id="SVGID_18_" gradientUnits="userSpaceOnUse" x1="22.9037" y1="24.1371" x2="26.6477" y2="35.2401">
          <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
          <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
          <stop offset="0.3763" style={{ stopColor: '#F2D070' }} />
          <stop offset="0.4657" style={{ stopColor: '#ECC35C' }} />
          <stop offset="0.5676" style={{ stopColor: '#E3B44E' }} />
          <stop offset="0.6237" style={{ stopColor: '#AE732A' }} />
          <stop offset="0.6528" style={{ stopColor: '#AE732A' }} />
          <stop offset="0.7152" style={{ stopColor: '#F0D76F' }} />
          <stop offset="0.7921" style={{ stopColor: '#F5E47D' }} />
          <stop offset="0.8441" style={{ stopColor: '#F7F2A5' }} />
          <stop offset="0.8919" style={{ stopColor: '#FFF1C5' }} />
          <stop offset="0.9376" style={{ stopColor: '#E3AC24' }} />
          <stop offset="0.9439" style={{ stopColor: '#E3AC24' }} />
          <stop offset="1" style={{ stopColor: '#FAC94B' }} />
        </linearGradient>
        <polyline style={{ fill: 'url(#SVGID_18_)' }} points="29,54.5 29,27.1 28.1,27.1 28.1,54.5 	" />
      </g>
      <g>
        <radialGradient id="SVGID_19_" cx="27.4371" cy="18.7148" r="18.665" gradientUnits="userSpaceOnUse">
          <stop offset="0" style={{ stopColor: '#326AB2' }} />
          <stop offset="0.5124" style={{ stopColor: '#326AB2' }} />
          <stop offset="0.9432" style={{ stopColor: '#203E77' }} />
        </radialGradient>
        <polyline style={{ fill: 'url(#SVGID_19_)' }} points="27,47 27,27.1 45.6,27.1 45.6,47 	" />
        <linearGradient id="SVGID_20_" gradientUnits="userSpaceOnUse" x1="36.9836" y1="19.8784" x2="40.7275" y2="30.9813">
          <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
          <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
          <stop offset="0.3763" style={{ stopColor: '#F2D070' }} />
          <stop offset="0.4657" style={{ stopColor: '#ECC35C' }} />
          <stop offset="0.5676" style={{ stopColor: '#E3B44E' }} />
          <stop offset="0.6237" style={{ stopColor: '#AE732A' }} />
          <stop offset="0.6528" style={{ stopColor: '#AE732A' }} />
          <stop offset="0.7152" style={{ stopColor: '#F0D76F' }} />
          <stop offset="0.7921" style={{ stopColor: '#F5E47D' }} />
          <stop offset="0.8441" style={{ stopColor: '#F7F2A5' }} />
          <stop offset="0.8919" style={{ stopColor: '#FFF1C5' }} />
          <stop offset="0.9376" style={{ stopColor: '#E3AC24' }} />
          <stop offset="0.9439" style={{ stopColor: '#E3AC24' }} />
          <stop offset="1" style={{ stopColor: '#FAC94B' }} />
        </linearGradient>
        <polyline style={{ fill: 'url(#SVGID_20_)' }} points="44.5,54.5 44.5,27.1 43.6,27.1 43.6,54.5 	" />
        <linearGradient id="SVGID_21_" gradientUnits="userSpaceOnUse" x1="22.9037" y1="24.1371" x2="26.6477" y2="35.2401">
          <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
          <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
          <stop offset="0.3763" style={{ stopColor: '#F2D070' }} />
          <stop offset="0.4657" style={{ stopColor: '#ECC35C' }} />
          <stop offset="0.5676" style={{ stopColor: '#E3B44E' }} />
          <stop offset="0.6237" style={{ stopColor: '#AE732A' }} />
          <stop offset="0.6528" style={{ stopColor: '#AE732A' }} />
          <stop offset="0.7152" style={{ stopColor: '#F0D76F' }} />
          <stop offset="0.7921" style={{ stopColor: '#F5E47D' }} />
          <stop offset="0.8441" style={{ stopColor: '#F7F2A5' }} />
          <stop offset="0.8919" style={{ stopColor: '#FFF1C5' }} />
          <stop offset="0.9376" style={{ stopColor: '#E3AC24' }} />
          <stop offset="0.9439" style={{ stopColor: '#E3AC24' }} />
          <stop offset="1" style={{ stopColor: '#FAC94B' }} />
        </linearGradient>
        <polyline style={{ fill: 'url(#SVGID_21_)' }} points="29,54.5 29,27.1 28.1,27.1 28.1,54.5 	" />
      </g>
      <radialGradient id="SVGID_22_" cx="27.4371" cy="18.7148" r="18.665" gradientUnits="userSpaceOnUse">
        <stop offset="0" style={{ stopColor: '#326AB2' }} />
        <stop offset="0.5124" style={{ stopColor: '#326AB2' }} />
        <stop offset="0.9432" style={{ stopColor: '#203E77' }} />
      </radialGradient>
      <polyline style={{ fill: 'url(#SVGID_22_)' }} points="27,47 27,27.1 45.6,27.1 45.6,47 " />
      <linearGradient id="SVGID_23_" gradientUnits="userSpaceOnUse" x1="36.9836" y1="19.8784" x2="40.7275" y2="30.9813">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.3763" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4657" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.5676" style={{ stopColor: '#E3B44E' }} />
        <stop offset="0.6237" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.6528" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.7152" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.7921" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8441" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.8919" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="0.9376" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.9439" style={{ stopColor: '#E3AC24' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <polyline style={{ fill: 'url(#SVGID_23_)' }} points="44.5,54.5 44.5,27.1 43.6,27.1 43.6,54.5 " />
      <linearGradient id="SVGID_24_" gradientUnits="userSpaceOnUse" x1="22.9037" y1="24.1371" x2="26.6477" y2="35.2401">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.3763" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4657" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.5676" style={{ stopColor: '#E3B44E' }} />
        <stop offset="0.6237" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.6528" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.7152" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.7921" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8441" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.8919" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="0.9376" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.9439" style={{ stopColor: '#E3AC24' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <polyline style={{ fill: 'url(#SVGID_24_)' }} points="29,54.5 29,27.1 28.1,27.1 28.1,54.5 " />
      <radialGradient id="SVGID_25_" cx="27.4371" cy="18.7148" r="18.665" gradientUnits="userSpaceOnUse">
        <stop offset="0" style={{ stopColor: '#326AB2' }} />
        <stop offset="0.5124" style={{ stopColor: '#326AB2' }} />
        <stop offset="0.9432" style={{ stopColor: '#203E77' }} />
      </radialGradient>
      <polyline style={{ fill: 'url(#SVGID_25_)' }} points="27,47 27,27.1 45.6,27.1 45.6,47 " />
      <linearGradient id="SVGID_26_" gradientUnits="userSpaceOnUse" x1="36.9836" y1="19.8784" x2="40.7275" y2="30.9813">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.3763" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4657" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.5676" style={{ stopColor: '#E3B44E' }} />
        <stop offset="0.6237" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.6528" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.7152" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.7921" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8441" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.8919" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="0.9376" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.9439" style={{ stopColor: '#E3AC24' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <polyline style={{ fill: 'url(#SVGID_26_)' }} points="44.5,54.5 44.5,27.1 43.6,27.1 43.6,54.5 " />
      <linearGradient id="SVGID_27_" gradientUnits="userSpaceOnUse" x1="22.9037" y1="24.1371" x2="26.6477" y2="35.2401">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.3763" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4657" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.5676" style={{ stopColor: '#E3B44E' }} />
        <stop offset="0.6237" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.6528" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.7152" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.7921" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8441" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.8919" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="0.9376" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.9439" style={{ stopColor: '#E3AC24' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <polyline style={{ fill: 'url(#SVGID_27_)' }} points="29,54.5 29,27.1 28.1,27.1 28.1,54.5 " />
      <radialGradient id="SVGID_28_" cx="27.4371" cy="18.7148" r="18.665" gradientUnits="userSpaceOnUse">
        <stop offset="0" style={{ stopColor: '#326AB2' }} />
        <stop offset="0.5124" style={{ stopColor: '#326AB2' }} />
        <stop offset="0.9432" style={{ stopColor: '#203E77' }} />
      </radialGradient>
      <polyline style={{ fill: 'url(#SVGID_28_)' }} points="27,47 27,27.1 45.6,27.1 45.6,47 " />
      <linearGradient id="SVGID_29_" gradientUnits="userSpaceOnUse" x1="36.9836" y1="19.8784" x2="40.7275" y2="30.9813">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.3763" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4657" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.5676" style={{ stopColor: '#E3B44E' }} />
        <stop offset="0.6237" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.6528" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.7152" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.7921" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8441" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.8919" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="0.9376" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.9439" style={{ stopColor: '#E3AC24' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <polyline style={{ fill: 'url(#SVGID_29_)' }} points="44.5,54.5 44.5,27.1 43.6,27.1 43.6,54.5 " />
      <linearGradient id="SVGID_30_" gradientUnits="userSpaceOnUse" x1="22.9037" y1="24.1371" x2="26.6477" y2="35.2401">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.3763" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4657" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.5676" style={{ stopColor: '#E3B44E' }} />
        <stop offset="0.6237" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.6528" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.7152" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.7921" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8441" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.8919" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="0.9376" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.9439" style={{ stopColor: '#E3AC24' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <polyline style={{ fill: 'url(#SVGID_30_)' }} points="29,54.5 29,27.1 28.1,27.1 28.1,54.5 " />
      <radialGradient id="SVGID_31_" cx="27.4371" cy="16.295" r="22.6056" gradientUnits="userSpaceOnUse">
        <stop offset="0" style={{ stopColor: '#326AB2' }} />
        <stop offset="0.5124" style={{ stopColor: '#326AB2' }} />
        <stop offset="0.8344" style={{ stopColor: '#203E77' }} />
      </radialGradient>
      <rect x="27" y="27.1" style={{ fill: 'url(#SVGID_31_)' }} width="18.6" height="25.6" />
      <linearGradient id="SVGID_32_" gradientUnits="userSpaceOnUse" x1="36.9836" y1="19.8784" x2="40.7275" y2="30.9813">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.3763" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4657" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.5676" style={{ stopColor: '#E3B44E' }} />
        <stop offset="0.6237" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.6528" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.7152" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.7921" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8441" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.8919" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="0.9376" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.9439" style={{ stopColor: '#E3AC24' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <polyline style={{ fill: 'url(#SVGID_32_)' }} points="44.5,54.5 44.5,27.1 43.6,27.1 43.6,54.5 " />
      <linearGradient id="SVGID_33_" gradientUnits="userSpaceOnUse" x1="22.9037" y1="24.1371" x2="26.6477" y2="35.2401">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.3763" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4657" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.5676" style={{ stopColor: '#E3B44E' }} />
        <stop offset="0.6237" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.6528" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.7152" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.7921" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8441" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.8919" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="0.9376" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.9439" style={{ stopColor: '#E3AC24' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <polyline style={{ fill: 'url(#SVGID_33_)' }} points="29,54.5 29,27.1 28.1,27.1 28.1,54.5 " />
      <linearGradient id="SVGID_34_" gradientUnits="userSpaceOnUse" x1="36.9836" y1="19.8784" x2="40.7275" y2="30.9813">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.3763" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4657" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.5676" style={{ stopColor: '#E3B44E' }} />
        <stop offset="0.6237" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.6528" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.7152" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.7921" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8441" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.8919" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="0.9376" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.9439" style={{ stopColor: '#E3AC24' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <polyline style={{ fill: 'url(#SVGID_34_)' }} points="44.5,54.5 44.5,27.1 43.6,27.1 43.6,54.5 " />
      <linearGradient id="SVGID_35_" gradientUnits="userSpaceOnUse" x1="22.9037" y1="24.1371" x2="26.6477" y2="35.2401">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.3763" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4657" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.6237" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.6528" style={{ stopColor: '#AE732A' }} />
        <stop offset="0.7152" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.7921" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8441" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.8919" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="0.9376" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.9439" style={{ stopColor: '#E3AC24' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <polyline style={{ fill: 'url(#SVGID_35_)' }} points="29,54.5 29,27.1 28.1,27.1 28.1,54.5 " />
      <g>
        <polygon
          style={{ fill: '#1E4280' }}
          points="48.7,58.4 46,57.8 46.1,60.6 43.5,59.4 43,62.2 40.7,60.6 39.7,63.2 37.8,61.2 36.3,63.5 34.8,61.2 
		32.8,63.2 31.8,60.6 29.5,62.2 29.1,59.4 26.5,60.6 26.6,57.8 23.8,58.4 24.4,55.6 21.7,55.7 22.8,53.1 20,52.7 21.6,50.4 19,49.4 
		21,47.4 18.7,45.9 21,44.4 19,42.5 21.6,41.5 20,39.2 22.8,38.7 21.7,36.1 24.4,36.2 23.8,33.5 26.6,34.1 26.5,31.3 29.1,32.4 
		29.6,29.7 31.8,31.3 32.9,28.7 34.8,30.7 36.3,28.3 37.8,30.7 39.7,28.7 40.7,31.3 43,29.7 43.5,32.4 46.1,31.3 46,34.1 48.7,33.5 
		48.1,36.2 50.9,36.2 49.8,38.7 52.5,39.2 50.9,41.5 53.5,42.5 51.5,44.4 53.9,45.9 51.5,47.4 53.5,49.4 50.9,50.4 52.5,52.7 
		49.8,53.2 50.9,55.7 48.1,55.6 	"
        />

        <linearGradient
          id="SVGID_36_"
          gradientUnits="userSpaceOnUse"
          x1="24.6783"
          y1="23.8675"
          x2="41.8842"
          y2="57.5772"
          gradientTransform="matrix(1 4.600000e-03 -4.600000e-03 1 0.4548 -0.3734)">
          <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
          <stop offset="0.1767" style={{ stopColor: '#F5E47D' }} />
          <stop offset="0.3763" style={{ stopColor: '#F2D070' }} />
          <stop offset="0.4657" style={{ stopColor: '#ECC35C' }} />
          <stop offset="0.5676" style={{ stopColor: '#E3B44E' }} />
          <stop offset="0.6237" style={{ stopColor: '#E19938' }} />
          <stop offset="0.6528" style={{ stopColor: '#D79528' }} />
          <stop offset="0.7152" style={{ stopColor: '#F0D76F' }} />
          <stop offset="0.7921" style={{ stopColor: '#F5E47D' }} />
          <stop offset="0.8441" style={{ stopColor: '#F7F2A5' }} />
          <stop offset="0.8919" style={{ stopColor: '#FFF1C5' }} />
          <stop offset="0.9376" style={{ stopColor: '#E3AC24' }} />
          <stop offset="0.9439" style={{ stopColor: '#E3AC24' }} />
          <stop offset="1" style={{ stopColor: '#F7BC4A' }} />
        </linearGradient>
        <polygon
          style={{ fill: 'url(#SVGID_36_)' }}
          points="48.6,58.3 45.9,57.7 46,60.5 43.5,59.3 43,62.1 40.7,60.5 39.7,63.1 37.8,61.1 36.3,63.4 34.8,61.1 
		32.9,63.1 31.9,60.5 29.6,62.1 29.1,59.3 26.6,60.4 26.6,57.7 23.9,58.3 24.5,55.6 21.8,55.6 22.9,53.1 20.1,52.6 21.7,50.3 
		19.2,49.3 21.1,47.4 18.8,45.9 21.1,44.4 19.2,42.5 21.7,41.5 20.1,39.2 22.9,38.8 21.8,36.2 24.5,36.3 23.9,33.6 26.6,34.2 
		26.6,31.4 29.1,32.5 29.6,29.8 31.9,31.4 32.9,28.8 34.8,30.8 36.3,28.5 37.8,30.8 39.7,28.8 40.7,31.4 43,29.8 43.5,32.5 46,31.4 
		45.9,34.2 48.6,33.6 48,36.3 50.8,36.2 49.7,38.8 52.4,39.2 50.8,41.5 53.4,42.5 51.4,44.4 53.8,45.9 51.4,47.4 53.4,49.3 
		50.8,50.3 52.4,52.6 49.7,53.1 50.8,55.6 48,55.6 	"
        />
      </g>
      <radialGradient id="SVGID_37_" cx="22.4702" cy="28.0503" r="27.7962" gradientTransform="matrix(0.9974 0 0 0.9974 -2.330000e-02 -7.530000e-02)" gradientUnits="userSpaceOnUse">
        <stop offset="0.1413" style={{ stopColor: '#4681C2' }} />
        <stop offset="0.3445" style={{ stopColor: '#417BBE' }} />
        <stop offset="0.6128" style={{ stopColor: '#326AB2' }} />
        <stop offset="0.6877" style={{ stopColor: '#2F63A8' }} />
        <stop offset="0.8155" style={{ stopColor: '#27528D' }} />
        <stop offset="0.98" style={{ stopColor: '#1A3661' }} />
        <stop offset="1" style={{ stopColor: '#18325B' }} />
      </radialGradient>
      <path
        style={{ fill: 'url(#SVGID_37_)', stroke: '#F5E47D', strokeWidth: '6.900165e-02', strokeMiterlimit: '10' }}
        d="M36.3,31.4c-8,0-14.5,6.5-14.5,14.5c0,8,6.5,14.5,14.5,14.5c8,0,14.5-6.5,14.5-14.5
	C50.8,37.9,44.3,31.4,36.3,31.4z"
      />
      <linearGradient
        id="SVGID_38_"
        gradientUnits="userSpaceOnUse"
        x1="36.7274"
        y1="25.4438"
        x2="57.5101"
        y2="53.1187"
        gradientTransform="matrix(0.9983 5.820000e-02 -5.820000e-02 0.9983 -0.1153 -2.9615)">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
        <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
        <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <path style={{ fill: 'url(#SVGID_38_)' }} d="M45,40.3l-1.4,1l-0.5-0.7l1.4-1l1.3-2.4l0.5,0.7l-0.9,1.6l1.8-0.3l0.5,0.7L45,40.3z" />
      <linearGradient
        id="SVGID_39_"
        gradientUnits="userSpaceOnUse"
        x1="39.8533"
        y1="25.3172"
        x2="60.6003"
        y2="52.9447"
        gradientTransform="matrix(0.999 4.530000e-02 -4.530000e-02 0.999 -4.1641 -2.0247)">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
        <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
        <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <path
        style={{ fill: 'url(#SVGID_39_)' }}
        d="M40.6,38.2l2.5-3.3l2.2,1.7l-0.4,0.6L43.3,36l-0.6,0.8l1.3,1l-0.4,0.6l-1.3-1l-0.6,0.8l1.5,1.2l-0.4,0.6
	L40.6,38.2z"
      />
      <linearGradient
        id="SVGID_40_"
        gradientUnits="userSpaceOnUse"
        x1="24.0534"
        y1="25.8944"
        x2="44.613"
        y2="53.2723"
        gradientTransform="matrix(0.9997 -2.610000e-02 2.610000e-02 0.9997 7.1646 1.6357)">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
        <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
        <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <path style={{ fill: 'url(#SVGID_40_)' }} d="M37.6,37.2l1.1-4l0.8,0.2l-0.9,3.3l1.8,0.5L40.2,38L37.6,37.2z" />
      <linearGradient
        id="SVGID_41_"
        gradientUnits="userSpaceOnUse"
        x1="22.189"
        y1="28.5325"
        x2="42.977"
        y2="56.2145"
        gradientTransform="matrix(0.9998 -2.170000e-02 2.170000e-02 0.9998 6.5709 0.3987)">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
        <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
        <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <path style={{ fill: 'url(#SVGID_41_)' }} d="M34.5,37.3l-0.4-4.1l0.8-0.1l0.3,3.4l1.9-0.2l0.1,0.7L34.5,37.3z" />
      <linearGradient
        id="SVGID_42_"
        gradientUnits="userSpaceOnUse"
        x1="25.4843"
        y1="31.3911"
        x2="46.2852"
        y2="59.0902"
        gradientTransform="matrix(0.9992 -4.200000e-02 4.200000e-02 0.9992 0.2595 -2.990874e-02)">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
        <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
        <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <path
        style={{ fill: 'url(#SVGID_42_)' }}
        d="M31.4,38.6l-1.7-3.8l2.5-1.1l0.3,0.7l-1.8,0.8l0.4,0.9l1.5-0.7L33,36l-1.5,0.7l0.4,0.9l1.8-0.8l0.3,0.7
	L31.4,38.6z"
      />
      <g>
        <g>
          <linearGradient
            id="SVGID_43_"
            gradientUnits="userSpaceOnUse"
            x1="20.4211"
            y1="36.7064"
            x2="41.1886"
            y2="64.3611"
            gradientTransform="matrix(0.9961 -8.830000e-02 8.830000e-02 0.9961 4.410000e-02 -1.4728)">
            <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
            <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
            <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
            <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
            <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
            <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
            <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
            <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
            <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
            <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
            <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
            <stop offset="1" style={{ stopColor: '#FAC94B' }} />
          </linearGradient>
          <path
            style={{ fill: 'url(#SVGID_43_)' }}
            d="M30.5,39.5L28.4,39l0.1,0.8l0.9,0.8l-0.5,0.6l-3.1-2.8l0.5-0.6l1.4,1.2l-0.4-2.3l0.7-0.7l0.3,2.1l2.9,0.6
			L30.5,39.5z"
          />
        </g>
      </g>
      <linearGradient id="SVGID_44_" gradientUnits="userSpaceOnUse" x1="34.5578" y1="27.4409" x2="52.85" y2="53.0742">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
        <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
        <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <path style={{ fill: 'url(#SVGID_44_)' }} d="M48.5,48.2l-1-2.1L47,46.9v1.4h-0.8v-4.6H47v2l1.4-2h0.9L48,45.5l1.4,2.8H48.5z" />
      <linearGradient id="SVGID_45_" gradientUnits="userSpaceOnUse" x1="32.1912" y1="28.9301" x2="50.8494" y2="55.0761">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
        <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
        <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <path
        style={{ fill: 'url(#SVGID_45_)' }}
        d="M45.4,47.8c-0.3,0.3-0.6,0.5-1,0.5c-0.4,0-0.8-0.2-1-0.5c-0.4-0.5-0.4-1-0.4-1.8c0-0.8,0-1.4,0.4-1.8
	c0.3-0.3,0.6-0.5,1-0.5c0.4,0,0.8,0.2,1,0.5c0.4,0.5,0.4,1,0.4,1.8C45.8,46.7,45.8,47.3,45.4,47.8z M44.8,44.7
	c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4,0.1-0.5,0.2c-0.1,0.2-0.2,0.4-0.2,1.3c0,0.9,0,1.1,0.2,1.3c0.1,0.1,0.3,0.2,0.5,0.2
	c0.2,0,0.4-0.1,0.5-0.2C45,47,45,46.8,45,45.9C45,45.1,45,44.8,44.8,44.7z"
      />
      <linearGradient id="SVGID_46_" gradientUnits="userSpaceOnUse" x1="30.2211" y1="30.6647" x2="48.8816" y2="56.814">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
        <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
        <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <path
        style={{ fill: 'url(#SVGID_46_)' }}
        d="M42.2,47.8c-0.3,0.3-0.6,0.5-1,0.5c-0.4,0-0.8-0.2-1-0.5c-0.4-0.5-0.4-1-0.4-1.8c0-0.8,0-1.4,0.4-1.8
	c0.3-0.3,0.6-0.5,1-0.5c0.4,0,0.8,0.2,1,0.5c0.4,0.5,0.4,1,0.4,1.8C42.6,46.7,42.6,47.3,42.2,47.8z M41.6,44.7
	c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4,0.1-0.5,0.2c-0.1,0.2-0.2,0.4-0.2,1.3c0,0.9,0,1.1,0.2,1.3c0.1,0.1,0.3,0.2,0.5,0.2
	c0.2,0,0.4-0.1,0.5-0.2c0.1-0.2,0.2-0.4,0.2-1.3C41.8,45.1,41.8,44.8,41.6,44.7z"
      />
      <linearGradient id="SVGID_47_" gradientUnits="userSpaceOnUse" x1="28.1832" y1="32.688" x2="46.6383" y2="58.5494">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
        <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
        <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <path
        style={{ fill: 'url(#SVGID_47_)' }}
        d="M38.2,48.2h-1.6v-4.6h1.5c0.8,0,1.2,0.5,1.2,1.3c0,0.5-0.3,0.8-0.5,0.9c0.2,0.1,0.5,0.4,0.5,1
	C39.3,47.8,38.9,48.2,38.2,48.2z M38,44.4h-0.7v1.1H38c0.3,0,0.5-0.2,0.5-0.5C38.5,44.7,38.4,44.4,38,44.4z M38.1,46.3h-0.8v1.1h0.8
	c0.3,0,0.5-0.3,0.5-0.6S38.4,46.3,38.1,46.3z"
      />
      <linearGradient id="SVGID_48_" gradientUnits="userSpaceOnUse" x1="25.8501" y1="34.7422" x2="44.2867" y2="60.5777">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
        <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
        <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <path style={{ fill: 'url(#SVGID_48_)' }} d="M32.6,48.2v-4.6h2.5v0.8h-1.8v1.1h1.5v0.8h-1.5v1.1h1.8v0.8H32.6z" />
      <linearGradient id="SVGID_49_" gradientUnits="userSpaceOnUse" x1="24.0642" y1="36.3089" x2="42.544" y2="62.205">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
        <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
        <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <path
        style={{ fill: 'url(#SVGID_49_)' }}
        d="M30.6,48.3c-0.8,0-1.4-0.6-1.4-1.6v-3h0.8v3c0,0.5,0.3,0.8,0.7,0.8c0.4,0,0.7-0.3,0.7-0.8v-3H32v3
	C32,47.6,31.4,48.3,30.6,48.3z"
      />
      <linearGradient id="SVGID_50_" gradientUnits="userSpaceOnUse" x1="21.4815" y1="38.4267" x2="39.9281" y2="64.2762">
        <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
        <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
        <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
        <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
        <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
        <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
        <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
        <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
        <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
        <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
        <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
        <stop offset="1" style={{ stopColor: '#FAC94B' }} />
      </linearGradient>
      <path style={{ fill: 'url(#SVGID_50_)' }} d="M26.5,48.2v-4.6h0.8v3.8H29v0.8H26.5z" />
      <g>
        <g>
          <linearGradient id="SVGID_51_" gradientUnits="userSpaceOnUse" x1="19.9248" y1="39.8434" x2="38.3806" y2="65.7059">
            <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
            <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
            <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
            <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
            <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
            <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
            <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
            <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
            <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
            <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
            <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
            <stop offset="1" style={{ stopColor: '#FAC94B' }} />
          </linearGradient>
          <path
            style={{ fill: 'url(#SVGID_51_)' }}
            d="M24.8,48.2h-1.6v-4.6h1.5c0.8,0,1.2,0.5,1.2,1.3c0,0.5-0.3,0.8-0.5,0.9c0.2,0.1,0.5,0.4,0.5,1
			C26,47.8,25.5,48.2,24.8,48.2z M24.7,44.4h-0.7v1.1h0.7c0.3,0,0.5-0.2,0.5-0.5C25.2,44.7,25,44.4,24.7,44.4z M24.7,46.3h-0.8v1.1
			h0.8c0.3,0,0.5-0.3,0.5-0.6S25.1,46.3,24.7,46.3z"
          />
        </g>
      </g>
      <g>
        <linearGradient
          id="SVGID_52_"
          gradientUnits="userSpaceOnUse"
          x1="18.6156"
          y1="27.7452"
          x2="40.8125"
          y2="57.3034"
          gradientTransform="matrix(0.9879 0.1551 -0.1551 0.9879 3.6105 3.6812)">
          <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
          <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
          <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
          <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
          <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
          <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
          <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
          <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
          <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
          <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
          <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
          <stop offset="1" style={{ stopColor: '#FAC94B' }} />
        </linearGradient>
        <path
          style={{ fill: 'url(#SVGID_52_)' }}
          d="M26.6,52.6c-0.2,0-0.4-0.2-0.6-0.4c-0.2-0.2-0.2-0.5-0.1-0.7c0.1-0.3,0.3-0.5,0.7-0.8
		c0.3-0.2,0.6-0.4,0.9-0.4c0.2,0,0.4,0.2,0.6,0.4c0.2,0.2,0.2,0.5,0.1,0.7c-0.1,0.3-0.3,0.5-0.7,0.8C27.2,52.5,26.9,52.7,26.6,52.6z
		 M27.7,51.4c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2,0-0.6,0.3c-0.4,0.3-0.5,0.4-0.5,0.5c0,0.1,0,0.2,0.1,0.3
		c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0,0.2,0,0.6-0.3C27.6,51.6,27.7,51.5,27.7,51.4z"
        />

        <linearGradient
          id="SVGID_53_"
          gradientUnits="userSpaceOnUse"
          x1="20.9755"
          y1="99.4223"
          x2="43.2091"
          y2="129.0294"
          gradientTransform="matrix(0.9891 0.1475 -0.1475 0.9891 11.7926 -67.4609)">
          <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
          <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
          <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
          <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
          <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
          <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
          <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
          <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
          <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
          <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
          <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
          <stop offset="1" style={{ stopColor: '#FAC94B' }} />
        </linearGradient>
        <path style={{ fill: 'url(#SVGID_53_)' }} d="M28.7,52.5l-0.4,0.4l0.6,0.7l-0.3,0.3l-0.6-0.7l-0.7,0.7l-0.3-0.3l1.8-1.7l1.1,1.1l-0.3,0.3L28.7,52.5z" />

        <linearGradient
          id="SVGID_54_"
          gradientUnits="userSpaceOnUse"
          x1="18.3121"
          y1="67.5371"
          x2="40.4988"
          y2="97.0816"
          gradientTransform="matrix(0.9934 0.1149 -0.1149 0.9934 7.5334 -34.9325)">
          <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
          <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
          <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
          <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
          <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
          <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
          <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
          <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
          <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
          <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
          <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
          <stop offset="1" style={{ stopColor: '#FAC94B' }} />
        </linearGradient>
        <path style={{ fill: 'url(#SVGID_54_)' }} d="M30.1,53.8l-0.4,0.5l0.8,0.6l-0.2,0.3l-0.8-0.6l-0.6,0.8l-0.4-0.3l1.4-2l1.3,0.9L31,54.5L30.1,53.8z" />

        <linearGradient
          id="SVGID_55_"
          gradientUnits="userSpaceOnUse"
          x1="17.5601"
          y1="46.248"
          x2="39.876"
          y2="75.9646"
          gradientTransform="matrix(0.9974 7.160000e-02 -7.160000e-02 0.9974 3.4616 -12.8853)">
          <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
          <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
          <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
          <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
          <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
          <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
          <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
          <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
          <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
          <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
          <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
          <stop offset="1" style={{ stopColor: '#FAC94B' }} />
        </linearGradient>
        <path style={{ fill: 'url(#SVGID_55_)' }} d="M30.4,56.5l1.1-2.2l0.4,0.2l-1.1,2.2L30.4,56.5z" />

        <linearGradient
          id="SVGID_56_"
          gradientUnits="userSpaceOnUse"
          x1="17.4242"
          y1="33.8622"
          x2="39.5659"
          y2="63.3468"
          gradientTransform="matrix(0.9983 5.820000e-02 -5.820000e-02 0.9983 2.7792 -0.398)">
          <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
          <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
          <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
          <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
          <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
          <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
          <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
          <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
          <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
          <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
          <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
          <stop offset="1" style={{ stopColor: '#FAC94B' }} />
        </linearGradient>
        <path
          style={{ fill: 'url(#SVGID_56_)' }}
          d="M32.1,57.2c-0.2-0.1-0.4-0.3-0.5-0.5c-0.1-0.3,0-0.6,0.1-1c0.1-0.4,0.2-0.7,0.6-0.8c0.2-0.1,0.4-0.1,0.7,0
		c0.4,0.2,0.6,0.5,0.6,1l-0.4-0.2c0-0.2,0-0.4-0.3-0.5c-0.1,0-0.2,0-0.3,0c-0.1,0.1-0.2,0.2-0.3,0.6C32,56.4,32,56.5,32,56.6
		c0,0.1,0.1,0.2,0.2,0.2c0.2,0.1,0.4,0,0.5-0.2l0.4,0.2C33,57.3,32.5,57.4,32.1,57.2z"
        />

        <linearGradient
          id="SVGID_57_"
          gradientUnits="userSpaceOnUse"
          x1="17.7133"
          y1="33.6583"
          x2="39.9307"
          y2="63.2437"
          gradientTransform="matrix(0.9996 2.970000e-02 -2.970000e-02 0.9996 1.6225 0.1566)">
          <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
          <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
          <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
          <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
          <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
          <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
          <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
          <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
          <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
          <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
          <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
          <stop offset="1" style={{ stopColor: '#FAC94B' }} />
        </linearGradient>
        <path style={{ fill: 'url(#SVGID_57_)' }} d="M33.5,57.7l0.5-2.4l0.5,0.1l-0.5,2.4L33.5,57.7z" />

        <linearGradient
          id="SVGID_58_"
          gradientUnits="userSpaceOnUse"
          x1="18.1924"
          y1="18.241"
          x2="40.3119"
          y2="47.6961"
          gradientTransform="matrix(0.9998 2.000000e-02 -2.000000e-02 0.9998 0.8937 15.5526)">
          <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
          <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
          <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
          <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
          <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
          <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
          <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
          <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
          <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
          <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
          <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
          <stop offset="1" style={{ stopColor: '#FAC94B' }} />
        </linearGradient>
        <path
          style={{ fill: 'url(#SVGID_58_)' }}
          d="M35.8,58l-0.1-0.4l-0.8-0.1l-0.2,0.4l-0.5,0l1-2.4l0.4,0l0.7,2.5L35.8,58z M35.4,56.2L35,57.1l0.6,0
		L35.4,56.2z"
        />

        <linearGradient
          id="SVGID_59_"
          gradientUnits="userSpaceOnUse"
          x1="20.6693"
          y1="0.3347"
          x2="42.7466"
          y2="29.7337"
          gradientTransform="matrix(0.9994 3.310000e-02 -3.310000e-02 0.9994 -0.4429 32.0719)">
          <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
          <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
          <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
          <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
          <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
          <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
          <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
          <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
          <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
          <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
          <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
          <stop offset="1" style={{ stopColor: '#FAC94B' }} />
        </linearGradient>
        <path style={{ fill: 'url(#SVGID_59_)' }} d="M36.6,58l-0.1-2.5l0.5,0l0.1,2l1.1-0.1l0,0.4L36.6,58z" />

        <linearGradient
          id="SVGID_60_"
          gradientUnits="userSpaceOnUse"
          x1="21.5027"
          y1="32.2275"
          x2="43.5659"
          y2="61.6076"
          gradientTransform="matrix(0.9987 -5.030000e-02 5.030000e-02 0.9987 -2.865 1.9073)">
          <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
          <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
          <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
          <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
          <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
          <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
          <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
          <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
          <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
          <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
          <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
          <stop offset="1" style={{ stopColor: '#FAC94B' }} />
        </linearGradient>
        <path
          style={{ fill: 'url(#SVGID_60_)' }}
          d="M40.5,56.9c-0.1,0.3-0.3,0.4-0.5,0.5c-0.2,0.1-0.5,0.1-0.7,0c-0.3-0.2-0.4-0.4-0.5-0.8
		c-0.1-0.4-0.3-0.7-0.1-1c0.1-0.2,0.3-0.4,0.5-0.5c0.5-0.2,0.9,0.1,1.1,0.4l-0.4,0.2c-0.1-0.2-0.3-0.3-0.5-0.2
		c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0,0.2,0.1,0.7c0.2,0.4,0.2,0.6,0.3,0.6c0.1,0.1,0.2,0.1,0.3,0c0.1,0,0.2-0.1,0.3-0.2
		c0-0.1,0-0.2,0-0.3l0-0.1l-0.4,0.2l-0.1-0.4l0.8-0.3l0.1,0.3C40.6,56.4,40.6,56.7,40.5,56.9z"
        />

        <linearGradient
          id="SVGID_61_"
          gradientUnits="userSpaceOnUse"
          x1="23.7902"
          y1="-15.747"
          x2="45.7849"
          y2="13.542"
          gradientTransform="matrix(0.9991 -4.360000e-02 4.360000e-02 0.9991 -0.9536 48.4246)">
          <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
          <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
          <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
          <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
          <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
          <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
          <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
          <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
          <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
          <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
          <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
          <stop offset="1" style={{ stopColor: '#FAC94B' }} />
        </linearGradient>
        <path
          style={{ fill: 'url(#SVGID_61_)' }}
          d="M42.1,56.5c-0.4,0.2-0.9,0.1-1.2-0.3l-0.8-1.4l0.4-0.2l0.8,1.4c0.1,0.2,0.4,0.3,0.6,0.2
		c0.2-0.1,0.3-0.4,0.1-0.6l-0.8-1.4l0.4-0.2l0.8,1.4C42.7,55.7,42.5,56.2,42.1,56.5z"
        />

        <linearGradient
          id="SVGID_62_"
          gradientUnits="userSpaceOnUse"
          x1="23.7539"
          y1="0.2054"
          x2="45.7495"
          y2="29.4954"
          gradientTransform="matrix(0.995 -9.970000e-02 9.970000e-02 0.995 -1.6182 33.9652)">
          <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
          <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
          <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
          <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
          <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
          <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
          <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
          <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
          <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
          <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
          <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
          <stop offset="1" style={{ stopColor: '#FAC94B' }} />
        </linearGradient>
        <path style={{ fill: 'url(#SVGID_62_)' }} d="M43.5,55.6L42,53.7l0.4-0.3l1.5,1.9L43.5,55.6z" />

        <linearGradient
          id="SVGID_63_"
          gradientUnits="userSpaceOnUse"
          x1="25.1586"
          y1="-18.2272"
          x2="47.2486"
          y2="11.1887"
          gradientTransform="matrix(0.9967 -8.200000e-02 8.200000e-02 0.9967 -6.930000e-02 50.5361)">
          <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
          <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
          <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
          <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
          <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
          <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
          <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
          <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
          <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
          <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
          <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
          <stop offset="1" style={{ stopColor: '#FAC94B' }} />
        </linearGradient>
        <path
          style={{ fill: 'url(#SVGID_63_)' }}
          d="M45.2,53.7c0,0.2-0.1,0.4-0.3,0.6l-0.6,0.6l-1.7-1.8l0.6-0.6c0.2-0.2,0.4-0.3,0.6-0.3c0.4,0,0.6,0.3,0.9,0.5
		C44.9,53.1,45.2,53.3,45.2,53.7z M43.8,52.8c-0.1,0-0.2,0-0.4,0.1l-0.2,0.2l1.1,1.1l0.2-0.2c0.1-0.1,0.2-0.2,0.1-0.4
		c0-0.1-0.1-0.3-0.4-0.5C44.1,52.9,44,52.8,43.8,52.8z"
        />

        <linearGradient
          id="SVGID_64_"
          gradientUnits="userSpaceOnUse"
          x1="12.856"
          y1="-72.3456"
          x2="34.9359"
          y2="-42.9434"
          gradientTransform="matrix(0.9913 -0.1321 0.1321 0.9913 20.6098 103.3833)">
          <stop offset="0" style={{ stopColor: '#FFEDC2' }} />
          <stop offset="0.1767" style={{ stopColor: '#F5EBA2' }} />
          <stop offset="0.2933" style={{ stopColor: '#F2D070' }} />
          <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
          <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
          <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
          <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
          <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
          <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
          <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
          <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
          <stop offset="1" style={{ stopColor: '#FAC94B' }} />
        </linearGradient>
        <path
          style={{ fill: 'url(#SVGID_64_)' }}
          d="M45.9,53.2l-2-1.4l0.9-1.3l0.4,0.2l-0.6,0.9l0.5,0.3l0.5-0.8l0.4,0.2l-0.5,0.8l0.5,0.3l0.6-0.9l0.4,0.2
		L45.9,53.2z"
        />
      </g>
      <g>
        <g>
          <linearGradient id="SVGID_65_" gradientUnits="userSpaceOnUse" x1="27.584" y1="32.7356" x2="46.7498" y2="55.1182">
            <stop offset="0.1656" style={{ stopColor: '#F2D070' }} />
            <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
            <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
            <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
            <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
            <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
            <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
            <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
            <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
            <stop offset="1" style={{ stopColor: '#FAC94B' }} />
          </linearGradient>
          <path
            style={{ fill: 'url(#SVGID_65_)' }}
            d="M36.2,38.9c2.9,0,5.3,1.7,6.4,4.2h0.4c-1.1-2.7-3.7-4.6-6.8-4.6c-3.1,0-5.7,1.9-6.8,4.6h0.4
			C30.9,40.7,33.4,38.9,36.2,38.9z"
          />
          <linearGradient id="SVGID_66_" gradientUnits="userSpaceOnUse" x1="24.5352" y1="35.3454" x2="43.7017" y2="57.7287">
            <stop offset="0.1656" style={{ stopColor: '#F2D070' }} />
            <stop offset="0.4" style={{ stopColor: '#F7F2A5' }} />
            <stop offset="0.4311" style={{ stopColor: '#ECC35C' }} />
            <stop offset="0.5289" style={{ stopColor: '#E3B44E' }} />
            <stop offset="0.6044" style={{ stopColor: '#F0D76F' }} />
            <stop offset="0.6489" style={{ stopColor: '#F5E47D' }} />
            <stop offset="0.8089" style={{ stopColor: '#E3AC24' }} />
            <stop offset="0.8889" style={{ stopColor: '#E4B229' }} />
            <stop offset="0.9511" style={{ stopColor: '#FFF1C5' }} />
            <stop offset="1" style={{ stopColor: '#FAC94B' }} />
          </linearGradient>
          <path
            style={{ fill: 'url(#SVGID_66_)' }}
            d="M36.2,52.9c-2.8,0-5.3-1.7-6.4-4.1h-0.4c1.1,2.7,3.7,4.5,6.8,4.5c3.1,0,5.7-1.9,6.8-4.5h-0.4
			C41.5,51.2,39.1,52.9,36.2,52.9z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#1C355E' }}
          d="M47.4,66.4c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6
		C47.2,65.9,47.4,66.1,47.4,66.4z M46.4,66.4c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.4-0.2,0.4-0.5c0-0.3-0.2-0.5-0.5-0.5
		C46.6,66,46.4,66.2,46.4,66.4z M46.7,66.8h-0.1v-0.6c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2,0c0,0,0.1,0.1,0.1,0.1
		c0,0.1-0.1,0.1-0.1,0.1v0c0.1,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1,0,0.1H47c0,0,0-0.1,0-0.1c0-0.1,0-0.1-0.1-0.1h-0.1V66.8z M46.7,66.4
		L46.7,66.4c0.1,0,0.2,0,0.2-0.1c0-0.1,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0V66.4z"
        />
      </g>
    </svg>
  );
};

export default Icon;
